import React from 'react';
import { Form } from 'antd';
import DspxModal from '../../../common/DspxModal/DspxModal';
import ChangeHeadOfHouseForm from '../../forms/ChangeHeadOfHouseForm/ChangeHeadOfHouseForm';
import ModalSubtitle from '../../ModalSubtitle/ModalSubtitle';
import { texts } from '../../../../constants/texts';

const ChangeHeadOfHouseNode = ({
  form,
  initialValue,
  onCancel,
  items = [],
  onSubmit,
  ...props
}) => {
  const { resetFields, validateFieldsAndScroll } = form;

  const handleCancel = () => {
    onCancel();
    resetFields();
  };

  const handleSubmit = () => {
    validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        await onSubmit(values);
        handleCancel();
      }
    });
  };

  return (
    <DspxModal
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText={initialValue ? texts.edit : texts.add}
      cancelText={texts.cancel}
      bodyStyle={{ padding: '24px 24px 14px' }}
      width={500}
      {...props}
    >
      <ModalSubtitle
        subtitle={`${initialValue ? 'Изменить' : 'Добавить'} председателя совета дома`}
      />
      <ChangeHeadOfHouseForm
        selectOptions={items}
        form={form}
        initialValue={initialValue}
      />
    </DspxModal>
  );
};

const ChangeHeadOfHouseModal = Form.create({ name: 'change_head_of_house' })(
  ChangeHeadOfHouseNode
);

export default ChangeHeadOfHouseModal;
